























import Vue from 'vue'
import * as qs from 'qs'

export default Vue.extend({
  name: 'ForgottenPassword',
  data() {
    return {
      phoneNumber: null
    }
  },
  methods: {
    /**
     * 電話番号をサーバに POST
     */
    async sendPhoneNumber() {
      await this.$http.post(
        '/get_sms/',
        qs.stringify({
          page: 'pw_forget'
        })
      )
    }
  }
})
